import constants from "../assets/constants";
import { createNewKPI } from "../data/omniDataModel";
import { helperGetIsoDate } from "../utils/helpers";
import { v4 as uuid } from "uuid";

const GenerateKPI = weeks => {
  let theReturn = [];

  for (let index = 0; index < weeks; ++index) {
    theReturn.push({
      //days in past is the value,
      //weeks*7
      _id: uuid(),
      dateOfEntry: helperGetIsoDate((weeks - index) * 7),
      kpiValue: 0,
    });
  }

  return theReturn;
};
export const GetKPIsByPillar = businessPillar => {
  let theReturn = [];
  let newKPI = null;

  newKPI = createNewKPI();
  newKPI._id = uuid();
  newKPI.omniData.name = "Bricks";
  newKPI.omniData.businessPillar = constants.empirePillarEnumes.leadership;
  newKPI.omniData.overRangeValue = 101;
  newKPI.omniData.targetValue = 100;
  newKPI.omniData.underRangeValue = 99;
  newKPI.omniData.values = GenerateKPI(13);
  //0 weeks
  newKPI.omniData.values[0].kpiValue = 110;
  newKPI.omniData.values[1].kpiValue = 95;
  newKPI.omniData.values[2].kpiValue = 104;
  newKPI.omniData.values[3].kpiValue = 75;
  newKPI.omniData.values[4].kpiValue = 80;
  newKPI.omniData.values[5].kpiValue = 125;
  newKPI.omniData.values[6].kpiValue = 103;
  newKPI.omniData.values[7].kpiValue = 99;
  newKPI.omniData.values[8].kpiValue = 84;
  newKPI.omniData.values[9].kpiValue = 108;
  newKPI.omniData.values[10].kpiValue = 130;
  newKPI.omniData.values[11].kpiValue = 111;
  newKPI.omniData.values[12].kpiValue = 82;
  //13 weeks
  theReturn.push(newKPI);

  newKPI = createNewKPI();
  newKPI._id = uuid();
  newKPI.omniData.name = "CCC";
  newKPI.omniData.businessPillar = constants.empirePillarEnumes.leadership;
  newKPI.omniData.overRangeValue = 31;
  newKPI.omniData.targetValue = 30;
  newKPI.omniData.underRangeValue = 29;
  newKPI.omniData.postUnitLabel = " Days";
  newKPI.omniData.values = GenerateKPI(13);
  //0 weeks
  newKPI.omniData.values[0].kpiValue = 32;
  newKPI.omniData.values[1].kpiValue = 28;
  newKPI.omniData.values[2].kpiValue = 31;
  newKPI.omniData.values[3].kpiValue = 31;
  newKPI.omniData.values[4].kpiValue = 27;
  newKPI.omniData.values[5].kpiValue = 30;
  newKPI.omniData.values[6].kpiValue = 30;
  newKPI.omniData.values[7].kpiValue = 30;
  newKPI.omniData.values[8].kpiValue = 30;
  newKPI.omniData.values[9].kpiValue = 29;
  newKPI.omniData.values[10].kpiValue = 30;
  newKPI.omniData.values[11].kpiValue = 31;
  newKPI.omniData.values[12].kpiValue = 31;
  //13 weeks
  theReturn.push(newKPI);

  newKPI = createNewKPI();
  newKPI._id = uuid();
  newKPI.omniData.name = "Widgets Per Day";
  newKPI.omniData.businessPillar = constants.empirePillarEnumes.opertations;
  newKPI.omniData.overRangeValue = 21;
  newKPI.omniData.targetValue = 20;
  newKPI.omniData.underRangeValue = 19;
  newKPI.omniData.values = GenerateKPI(13);
  //0 weeks
  newKPI.omniData.values[0].kpiValue = 20;
  newKPI.omniData.values[1].kpiValue = 21;
  newKPI.omniData.values[2].kpiValue = 18;
  newKPI.omniData.values[3].kpiValue = 23;
  newKPI.omniData.values[4].kpiValue = 20;
  newKPI.omniData.values[5].kpiValue = 20;
  newKPI.omniData.values[6].kpiValue = 18;
  newKPI.omniData.values[7].kpiValue = 24;
  newKPI.omniData.values[8].kpiValue = 19;
  newKPI.omniData.values[9].kpiValue = 22;
  newKPI.omniData.values[10].kpiValue = 20;
  newKPI.omniData.values[11].kpiValue = 17;
  newKPI.omniData.values[12].kpiValue = 25;
  //13 weeks
  theReturn.push(newKPI);

  newKPI = createNewKPI();
  newKPI._id = uuid();
  newKPI.omniData.name = "Error Rate";
  newKPI.omniData.businessPillar = constants.empirePillarEnumes.opertations;
  newKPI.omniData.overRangeValue = 1;
  newKPI.omniData.targetValue = 0;
  newKPI.omniData.underRangeValue = 0;
  newKPI.omniData.values = GenerateKPI(13);
  //0 weeks
  newKPI.omniData.values[0].kpiValue = 0;
  newKPI.omniData.values[1].kpiValue = 1;
  newKPI.omniData.values[2].kpiValue = 0;
  newKPI.omniData.values[3].kpiValue = 0;
  newKPI.omniData.values[4].kpiValue = 0;
  newKPI.omniData.values[5].kpiValue = 2;
  newKPI.omniData.values[6].kpiValue = 0;
  newKPI.omniData.values[7].kpiValue = 0;
  newKPI.omniData.values[8].kpiValue = 1;
  newKPI.omniData.values[9].kpiValue = 0;
  newKPI.omniData.values[10].kpiValue = 0;
  newKPI.omniData.values[11].kpiValue = 2;
  newKPI.omniData.values[12].kpiValue = 1;
  //13 weeks
  theReturn.push(newKPI);

  newKPI = createNewKPI();
  newKPI._id = uuid();
  newKPI.omniData.name = "Cost Per Conversion";
  newKPI.omniData.businessPillar = constants.empirePillarEnumes.marketing;
  newKPI.omniData.overRangeValue = 101;
  newKPI.omniData.targetValue = 100;
  newKPI.omniData.underRangeValue = 99;
  newKPI.omniData.preUnitSymbol = "$";
  newKPI.omniData.values = GenerateKPI(13);
  //0 weeks
  newKPI.omniData.values[0].kpiValue = 92;
  newKPI.omniData.values[1].kpiValue = 103;
  newKPI.omniData.values[2].kpiValue = 100;
  newKPI.omniData.values[3].kpiValue = 110;
  newKPI.omniData.values[4].kpiValue = 115;
  newKPI.omniData.values[5].kpiValue = 99;
  newKPI.omniData.values[6].kpiValue = 84;
  newKPI.omniData.values[7].kpiValue = 100;
  newKPI.omniData.values[8].kpiValue = 103;
  newKPI.omniData.values[9].kpiValue = 94;
  newKPI.omniData.values[10].kpiValue = 96;
  newKPI.omniData.values[11].kpiValue = 93;
  newKPI.omniData.values[12].kpiValue = 110;
  //13 weeks
  theReturn.push(newKPI);

  newKPI = createNewKPI();
  newKPI._id = uuid();
  newKPI.omniData.name = "Cost Per Lead";
  newKPI.omniData.businessPillar = constants.empirePillarEnumes.marketing;
  newKPI.omniData.overRangeValue = 11;
  newKPI.omniData.targetValue = 10;
  newKPI.omniData.underRangeValue = 9;
  newKPI.omniData.preUnitSymbol = "$";
  newKPI.omniData.values = GenerateKPI(13);
  //0 weeks
  newKPI.omniData.values[0].kpiValue = 7;
  newKPI.omniData.values[1].kpiValue = 11;
  newKPI.omniData.values[2].kpiValue = 12;
  newKPI.omniData.values[3].kpiValue = 8;
  newKPI.omniData.values[4].kpiValue = 10;
  newKPI.omniData.values[5].kpiValue = 12;
  newKPI.omniData.values[6].kpiValue = 14;
  newKPI.omniData.values[7].kpiValue = 8;
  newKPI.omniData.values[8].kpiValue = 9;
  newKPI.omniData.values[9].kpiValue = 10;
  newKPI.omniData.values[10].kpiValue = 8;
  newKPI.omniData.values[11].kpiValue = 12;
  newKPI.omniData.values[12].kpiValue = 13;
  //13 weeks
  theReturn.push(newKPI);

  newKPI = createNewKPI();
  newKPI._id = uuid();
  newKPI.omniData.name = "Gross Profit";
  newKPI.omniData.businessPillar = constants.empirePillarEnumes.finance;
  newKPI.omniData.overRangeValue = 50001;
  newKPI.omniData.targetValue = 50000;
  newKPI.omniData.underRangeValue = 49999;
  newKPI.omniData.preUnitSymbol = "$";
  newKPI.omniData.values = GenerateKPI(13);
  //0 weeks
  newKPI.omniData.values[0].kpiValue = 47000;
  newKPI.omniData.values[1].kpiValue = 50000;
  newKPI.omniData.values[2].kpiValue = 58000;
  newKPI.omniData.values[3].kpiValue = 40000;
  newKPI.omniData.values[4].kpiValue = 42000;
  newKPI.omniData.values[5].kpiValue = 63000;
  newKPI.omniData.values[6].kpiValue = 50000;
  newKPI.omniData.values[7].kpiValue = 48000;
  newKPI.omniData.values[8].kpiValue = 43000;
  newKPI.omniData.values[9].kpiValue = 54000;
  newKPI.omniData.values[10].kpiValue = 65000;
  newKPI.omniData.values[11].kpiValue = 55000;
  newKPI.omniData.values[12].kpiValue = 45000;
  //13 weeks
  theReturn.push(newKPI);

  newKPI = createNewKPI();
  newKPI._id = uuid();
  newKPI.omniData.name = "Cash On Hand";
  newKPI.omniData.businessPillar = constants.empirePillarEnumes.finance;
  newKPI.omniData.overRangeValue = 260000;
  newKPI.omniData.targetValue = 250000;
  newKPI.omniData.underRangeValue = 240000;
  newKPI.omniData.preUnitSymbol = "$";
  newKPI.omniData.values = GenerateKPI(13);
  //0 weeks
  newKPI.omniData.values[0].kpiValue = 250000;
  newKPI.omniData.values[1].kpiValue = 250000;
  newKPI.omniData.values[2].kpiValue = 250000;
  newKPI.omniData.values[3].kpiValue = 250000;
  newKPI.omniData.values[4].kpiValue = 250000;
  newKPI.omniData.values[5].kpiValue = 250000;
  newKPI.omniData.values[6].kpiValue = 250000;
  newKPI.omniData.values[7].kpiValue = 250000;
  newKPI.omniData.values[8].kpiValue = 250000;
  newKPI.omniData.values[9].kpiValue = 250000;
  newKPI.omniData.values[10].kpiValue = 250000;
  newKPI.omniData.values[11].kpiValue = 250000;
  newKPI.omniData.values[12].kpiValue = 250000;
  //13 weeks
  theReturn.push(newKPI);

  newKPI = createNewKPI();
  newKPI._id = uuid();
  newKPI.omniData.name = "Training Hours";
  newKPI.omniData.businessPillar = constants.empirePillarEnumes.personnel;
  newKPI.omniData.overRangeValue = 11;
  newKPI.omniData.targetValue = 10;
  newKPI.omniData.underRangeValue = 9;
  newKPI.omniData.values = GenerateKPI(13);
  //0 weeks
  newKPI.omniData.values[0].kpiValue = 12;
  newKPI.omniData.values[1].kpiValue = 8;
  newKPI.omniData.values[2].kpiValue = 10;
  newKPI.omniData.values[3].kpiValue = 10;
  newKPI.omniData.values[4].kpiValue = 12;
  newKPI.omniData.values[5].kpiValue = 9;
  newKPI.omniData.values[6].kpiValue = 8;
  newKPI.omniData.values[7].kpiValue = 7;
  newKPI.omniData.values[8].kpiValue = 12;
  newKPI.omniData.values[9].kpiValue = 10;
  newKPI.omniData.values[10].kpiValue = 10;
  newKPI.omniData.values[11].kpiValue = 11;
  newKPI.omniData.values[12].kpiValue = 9;
  //13 weeks
  theReturn.push(newKPI);

  newKPI = createNewKPI();
  newKPI._id = uuid();
  newKPI.omniData.name = "Attrition";
  newKPI.omniData.businessPillar = constants.empirePillarEnumes.personnel;
  newKPI.omniData.overRangeValue = 1;
  newKPI.omniData.targetValue = 0;
  newKPI.omniData.underRangeValue = 0;
  newKPI.omniData.values = GenerateKPI(13);
  //0 weeks
  newKPI.omniData.values[0].kpiValue = 0;
  newKPI.omniData.values[1].kpiValue = 0;
  newKPI.omniData.values[2].kpiValue = 0;
  newKPI.omniData.values[3].kpiValue = 1;
  newKPI.omniData.values[4].kpiValue = 1;
  newKPI.omniData.values[5].kpiValue = 0;
  newKPI.omniData.values[6].kpiValue = 0;
  newKPI.omniData.values[7].kpiValue = 0;
  newKPI.omniData.values[8].kpiValue = 0;
  newKPI.omniData.values[9].kpiValue = 1;
  newKPI.omniData.values[10].kpiValue = 0;
  newKPI.omniData.values[11].kpiValue = 0;
  newKPI.omniData.values[12].kpiValue = 0;
  //13 weeks
  theReturn.push(newKPI);

  return theReturn;
};
